<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="well-title">
        <div class="col-md-12">PTP Shipping Locations</div>
    </div>
    <div class="col-md-12 well-content">
        <div style="margin-bottom: 16px; display: flex; gap: 8px; align-items: center">
            <button nz-button nzType="primary" (click)="addLocation()">Add Location</button>
        </div>
        <nz-table #locationTable [nzData]="locations" nzTableLayout="fixed" nzBordered="true" [nzLoading]="loading">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>City</th>
                    <th>State</th>
                    <th nzWidth="160px"></th>
                </tr>
            </thead>
            <tbody>
                @for (location of locationTable.data; track location.PTPShippingLocationID) {
                    <tr>
                        <td>{{ location.ShippingLocation }}</td>
                        <td>{{ location.ShipToCity }}</td>
                        <td>{{ location.ShipToState }}</td>
                        <td style="text-align: center">
                            <button
                                nz-button
                                class="btn btn-default"
                                (click)="editLocation(location.PTPShippingLocationID)">
                                Edit
                            </button>
                            <button
                                nz-button
                                nzDanger
                                style="margin-left: 8px"
                                nz-popconfirm
                                nzPopconfirmTitle="Are you sure you want to delete this location?"
                                (nzOnConfirm)="deleteLocation(location.PTPShippingLocationID)">
                                Delete
                            </button>
                        </td>
                    </tr>
                }
            </tbody>
        </nz-table>
    </div>
</div>
